import { Routes } from '@angular/router';
import { AuthShellComponent } from './auth/auth.component';
import { GuestGuard } from './core/guards/guest.guard';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthShellComponent,
    canActivateChild: [GuestGuard],
    children: [
      { 
        path: 'login', 
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent) 
      },
      { 
        path: 'verifyMfa', 
        loadComponent: () => import('./auth/otp/otp.component').then(m => m.OtpComponent) },
      { 
        path: 'forgot-password', 
        loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      { 
        path: 'reset-password', 
        loadComponent: () => import('./auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent) 
      },
      { 
        path: 'activate-account', 
        loadComponent: () => import('./auth/force-activate/force-activate.component').then(m => m.ForceActivateComponent) 
      },
      { 
        path: '', 
        redirectTo: 'login', 
        pathMatch: 'full' 
      },
    ],
  },

  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'upload-history', 
        loadComponent: () => import('./features/upload-history/upload-history.component').then(m => m.UploadHistoryComponent)
      },
      { 
        path: 'file-upload', 
        loadComponent: () => import('./features/file-upload/file-upload.component').then(m => m.FileUploadComponent) 
      },
      { 
        path: 'users', 
        loadComponent: () => import('./features/users/users.component').then(m => m.UsersComponent) 
      },
      { 
        path: 'activity', 
        loadComponent: () => import('./features/activity-list/activity-list.component').then(m => m.ActivityListComponent) 
      },
      { 
        path: 'cookie-policy', 
        loadComponent: () => import('./features/cookie-policy/cookie-policy.component').then(m => m.CookiePolicyComponent) 
      },
      { 
        path: 'privacy-policy', 
        loadComponent: () => import('./features/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent) 
      },
      { 
        path: '', 
        redirectTo: 'upload-history', 
        pathMatch: 'full' 
      },
    ],
  },

  { 
    path: '**', 
    redirectTo: 'auth/login' 
  },
];
